<template>
    <el-row>
        <el-col v-if="loading">
            <h5 class="text-center mt-5">Please Wait....</h5>
        </el-col>
        <el-col v-else>
            <el-card class="box-card box-d-card ml-4 mr-4" v-if="enquiry != null">
                <template class="el-card__header_b" #header>
                    <div class="card-headere">
                        <span>
                            <el-tag class="mx-1" effect="dark">
                                TRIP ID - {{ enquiry.id }}
                            </el-tag>

                            <el-tag class="mx-1" effect="dark">
                                {{ enquiry.enq_date }}
                            </el-tag>

                            <el-tag
                                class="mx-1"
                                effect="dark"
                                v-bind:class="{
                                    'bg-warning': enquiry.status == 'Pending',
                                    'bg-red': enquiry.status == 'Closed',
                                    'bg-success': enquiry.status == 'Converted',
                                    'bg-info': enquiry.status == 'InProgress'
                                }"
                            >{{ enquiry.status }}</el-tag>

                            <el-tag
                                v-if="enquiry.reverify == 1"
                                class="mx-1"
                                effect="dark"
                                type="info"
                            >Reverify</el-tag>

                            <el-tag
                                v-else
                                class="mx-1"
                                effect="dark"
                                type="info"
                            >{{ enquiry.qc_stage == null ? 'Fresh Lead' : enquiry.qc_stage }}</el-tag>
                        </span>

                        <span>
                            <enquiry-action
                                :enquiry="enquiry"
                                :languages="languages"
                                :user="user"
                                @actionevent="$emit('actionevent')"
                            ></enquiry-action>
                            <el-tag @click="closeenquiry" v-if="enquiryid != null">Back</el-tag>
                        </span>
                    </div>
                </template>

                <el-row :gutter="20">
                    <el-col :span="6">
                        <TravellerDetails @saved="getdetails()" :enquiry="enquiry" />

                        <el-card class="mini-box-card mt-2" v-if="enquiry.related.length > 0">
                            <template class="mini-card-header" #header>
                                <span>Duplicate</span>
                            </template>

                            <el-card
                                class="mt-1 enqdetcard"
                                v-for="related in enquiry.related"
                                :key="related.id"
                                @click="viewenquiry(related.id)"
                            >
                                CDM{{ related.id }}
                                <el-tag :type="related.status == 'Closed' ? 'danger' : 'primary'">{{ related.status }}</el-tag>
                            </el-card>
                        </el-card>
                    </el-col>

                    <el-col :span="18">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <TravellerRequirement @saved="getdetails()" :enquiry="enquiry" />
                            </el-col>
                            <el-col class="mt-2" :span="24">
                                <EnquiryLogs @saved="getdetails()" :enquiry="enquiry" />
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>
import TravellerDetails from './Enquiry/Components/TravellerDetails';
import TravellerRequirement from './Enquiry/Components/TravellerRequirement';
import EnquiryLogs from './Enquiry/Components/EnquiryLogs';
import { ElButton, ElCard, ElTag, ElRow, ElCol } from 'element-plus';
import $ from 'jquery';
import moment from 'moment';
const yourhandle = require('countrycitystatejson');

export default {
    name: "QcEnquiry",
    props: {
        enquirydet: {
            type: Object,
            default() {
                return null;
            }
        },
        user: {
            type: Object,
            default() {
                return null;
            }
        },
        enquiryid: {
            type: Number,
            default() {
                return null;
            }
        },
        languages: {
            type: Array,
            default() {
                return null;
            }
        },
    },
    emits: ["actionevent", "popupenquiry", "closeenquiry"],
    components: {
        EnquiryLogs, ElButton, ElCard, ElTag, ElRow, ElCol,
        TravellerDetails, TravellerRequirement
    },
    data() {
        return {
            id: '',
            enquiry: null,
            loading: false,
        };
    },
    created() {
        if (this.enquirydet != null) {
            this.enquiry = this.enquirydet;
            this.id = this.enquiry.id;
        } else {
            this.id = this.enquiryid;
            this.getdetails();
        }
    },
    methods: {
        convertHMS(value) {
            const sec = parseInt(value, 10);
            let hours = Math.floor(sec / 3600);
            let minutes = Math.floor((sec - (hours * 3600)) / 60);
            let seconds = sec - (hours * 3600) - (minutes * 60);
            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            if (hours > 0) {
                return hours + ':' + minutes + ':' + seconds;
            } else if (minutes > 0) {
                return minutes + ':' + seconds;
            } else {
                return seconds;
            }
        },
        viewenquiry(enquiry) {
            this.$emit('popupenquiry', enquiry);
        },
        closeenquiry() {
            this.$emit('closeenquiry');
        },
        getdetails() {
            let currentObj = this;
            this.loading = true;
            axios.post('/qc/getqcenquirydetails?id=' + this.id).then(function (response) {
                currentObj.loading = false;
                currentObj.enquiry = response.data.enquiry;
            }).catch(function (error) {
            });
        },
    }
};
</script>

<style scoped>
.card-headere {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>